import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(private httpClient: HttpClient) { }

  downloadFile(id: number) {
    return this.httpClient.get('/api/Utils/DownloadFile/' + id, { responseType: 'blob' });
  }

  exportByTTTS(searchValue: string, tuNgay: string, denNgay: string): any {
    return this.httpClient.get('/api/Utils/ExportDanhSachHoSoByThongTinTaiSan?searchValue=' + searchValue
      + '&tuNgay=' + tuNgay + '&denNgay=' + denNgay, { responseType: 'blob' });
  }

  exportByNYC(searchValue: string, tuNgay: string, denNgay: string): any {
    return this.httpClient.get('/api/Utils/ExportDanhSachHoSoByNYC?searchValue=' + searchValue
      + '&tuNgay=' + tuNgay + '&denNgay=' + denNgay, { responseType: 'blob' });
  }

  exportBySoCongChung(searchValue: string, tuNgay: string, denNgay: string): any {
    return this.httpClient.get('/api/Utils/ExportDanhSachHoSoBySoCongChung?searchValue=' + searchValue
      + '&tuNgay=' + tuNgay + '&denNgay=' + denNgay, { responseType: 'blob' });
  }
}
